import MenuItem from './menuItem';

export default class MenuItemGroup {
  type = 'menu-item-group';

  constructor(params) {
    this.name = params.name;
    this.displayName = params.displayName;
    this.excludedLabels = params.excludedLabels;
    this.menuItemsPrimary = params.menuItemsPrimary.map((item) => new MenuItem(item));
    this.menuItemsSecondary = params.menuItemsSecondary?.map((item) => new MenuItem(item));
    this.tile = params.tile;
    return this;
  }
}
